import React, { useState } from 'react';
import { ConfigurationSection, SpaceBetweenRow } from "@features/settings/pages/StyleComponents";
import { BodyLarge, BodyRegular } from "../../atoms/fonts/Body";
import Colours from "../../atoms/Colours";
import { SimpleSpinner } from "../../atoms/SimpleSpinner";
import { Switch } from "../../atoms/Switch";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser } from '@shared/store/auth.duck';
import { updateHolidayBooking } from '@features/auth/store/onboarding.duck';
import { useTranslation } from "react-i18next";

export function HolidayBookingSetting(props: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const {t} = useTranslation();

  const onChange = (val: boolean) => {
    setIsLoading(true);
    try {
      dispatch(updateHolidayBooking(val));
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <ConfigurationSection>
      <SpaceBetweenRow>
        <BodyLarge colour={Colours.blue}>{t('settings.holiday-tracking.title')}</BodyLarge>
        {isLoading ? <SimpleSpinner size={32} /> : <Switch value={!!user?.companyEntity.enableHolidayBooking} label="" onChange={onChange}/>}
      </SpaceBetweenRow>
      {user?.companyEntity.enableHolidayBooking ? <>
      </> : <>
        <BodyRegular style={{marginBottom: 8}}>{t('settings.holiday-tracking.message')}</BodyRegular>
      </>}
    </ConfigurationSection>
  )
}

interface Props {
}
